
import { defineComponent } from 'vue';
import Temporizador from './Temporizador.vue';
export default defineComponent({
  name: 'Formulario-Nome',
  emits: [ 'aoSalvarTarefa' ],
  components: {
    Temporizador
  },
  data() {
    return {
      descricao: ''
    }
  },
  methods: {
    finalizarTarefa(tempoDecorrido: number): void {
      this.$emit('aoSalvarTarefa', {
        duracaoEmSegundos: tempoDecorrido,
        descricao: this.descricao
      })
      this.descricao = ''
    }
  }


})
